import { createAuthAxios } from './axiosInstance';

// Token + refresh gérés par l'instance centrale
const authAxios = createAuthAxios();
authAxios.interceptors.request.use((config) => {
    // Pas d'autorisation sur ces routes pour l'instant (chantier JWT à part) : le garage est identifié par son id
    try {
        const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id;
        if (garageId) config.params = { ...(config.params || {}), garageId };
    } catch { /* identité absente */ }
    return config;
});

// Événement envoyé après une action qui change les rendez-vous : le badge de la barre latérale et le widget
// de l'en-tête se rechargent à ce moment-là, au lieu d'interroger le serveur toutes les 2 minutes.
export const APPOINTMENTS_CHANGED = 'appointments:changed';
const notifyAppointmentsChanged = () => window.dispatchEvent(new Event(APPOINTMENTS_CHANGED));

export const appointmentService = {
    async createAppointment(data: any) {
        const response = await authAxios.post('/inspections/appointments', data);
        notifyAppointmentsChanged();
        return response.data;
    },
    async getAppointments(params?: any) {
        const response = await authAxios.get('/inspections/appointments', { params });
        return response.data;
    },
    async getAppointmentById(appointmentId: string) {
        const response = await authAxios.get(`/inspections/appointments/${appointmentId}`);
        return response.data;
    },
    async updateStatus(appointmentId: string, data: any) {
        const response = await authAxios.put(`/inspections/appointments/${appointmentId}/status`, data);
        notifyAppointmentsChanged();
        return response.data;
    },
    async reschedule(appointmentId: string, data: any) {
        const response = await authAxios.put(`/inspections/appointments/${appointmentId}/reschedule`, data);
        notifyAppointmentsChanged();
        return response.data;
    },
    async getAvailableSlots(date: string, duration?: number) {
        const response = await authAxios.get('/inspections/appointments/slots', { params: { date, duration } });
        return response.data;
    },
    // Réponse du garage à une demande ou contre-proposition du client
    async respond(appointmentId: string, payload: { action: 'ACCEPT' | 'REFUSE' | 'COUNTER'; date?: string; timeSlot?: string; reason?: string; note?: string }) {
        const response = await authAxios.post(`/inspections/appointments/${appointmentId}/respond`, payload);
        notifyAppointmentsChanged();
        return response.data;
    },
    async getStats(params?: { from?: string; to?: string }) {
        const response = await authAxios.get('/inspections/appointments/stats', { params });
        return response.data;
    },
    // Créneaux libres suggérés pour « Proposer plutôt »
    async getSuggestions(appointmentId: string, count = 3) {
        const response = await authAxios.get(`/inspections/appointments/${appointmentId}/suggestions`, { params: { count } });
        return response.data;
    },
    async getConfig() {
        const response = await authAxios.get('/inspections/appointments/config');
        return response.data;
    },
    async updateConfig(data: any) {
        const response = await authAxios.put('/inspections/appointments/config', data);
        return response.data;
    }
};
